<template>
  <main class="bg-[#D5CBB8]">
    <!-- Growth and Accomplishment section -->
    <div
      class="md:px-12 max-w-screen-2xl mx-auto"
      id="achievement"
    >
      <div class="py-20">
        <h1 class="text-center text-lg font-bold">Growth & Accomplishments</h1>
        <p class="text-center mt-4">
          "...Change your mind to change your life." Barka U. Mshelia
        </p>
      </div>
    </div>

    <!-- Slider implementation with carousel -->
     <div class="bg-black">
       <div class="md:px-6 max-w-screen-2xl mx-auto py-10">
         <div id="default-carousel" class="relative" data-carousel="slide">
           <!-- Carousel wrapper -->
           <div class="relative overflow-hidden rounded-lg" data-carousel-item>
             <!-- Carousel container -->
             <div
               class="flex transition-transform duration-700 ease-in-out lg:gap-x-2"
               :style="{
                 transform: `translateX(-${activeIndex * (100 / cardsPerSlide)}%)`,
               }"
             >
               <!-- Awards -->
               <div
                 v-for="(award, index) in awards"
                 :key="index"
                 class="min-w-[100%] sm:min-w-[50%] md:min-w-[33.33%] lg:min-w-[25%] text-center"
               >
                 <div class="px-2">
                   <img
                     :src="award.img"
                     class="mx-auto w-24 h-24 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full object-cover"
                     :alt="award.alt"
                   />
                   <p class="mt-3 text-xl text-white font-semibold">
                     {{ award.year }}
                   </p>
                   <p class="text-sm text-gray-300">{{ award.title }}</p>
                 </div>
               </div>
             </div>
           </div>
   
           <!-- Slider controls -->
           <button
             type="button"
             class="absolute top-1/2 left-1 transform -translate-y-1/2 z-30 flex items-center justify-center h-9 w-9 bg-gray-700 hover:bg-gray-900 rounded-full"
             @click="prevSlide"
           >
             <svg
               class="w-5 h-5 text-white"
               fill="none"
               stroke="currentColor"
               viewBox="0 0 24 24"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 stroke-width="2"
                 d="M15 19l-7-7 7-7"
               />
             </svg>
           </button>
           <button
             type="button"
             class="absolute top-1/2 right-1 transform -translate-y-1/2 z-30 flex items-center justify-center h-9 w-9 bg-gray-700 hover:bg-gray-900 rounded-full"
             @click="nextSlide"
           >
             <svg
               class="w-5 h-5 text-white"
               fill="none"
               stroke="currentColor"
               viewBox="0 0 24 24"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 stroke-width="2"
                 d="M9 5l7 7-7 7"
               />
             </svg>
           </button>
         </div>
       </div>
     </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      cardsPerSlide: 4,
      totalSlides: 0,
      awards: [
        {
          img: require("../assets/images/mshel-club.jpeg"),
          year: "2022",
          title: "African Genius Award",
          alt: "African Genius Award",
        },
        {
          img: require("../assets/images/mshel-club.jpeg"),
          year: "2021",
          title: "Titans of Africa, Dubai",
          alt: "Titans of Africa",
        },
        {
          img: require("../assets/images/mshel-club.jpeg"),
          year: "2021",
          title: "Golden Key Award",
          alt: "Golden Key Award",
        },
        {
          img: require("../assets/images/about-barka.jpeg"),
          year: "2020, 2021",
          title: "Best Impact Investment Firm",
          alt: "Best Impact Investment Firm",
        },
        {
          img: require("../assets/images/mshel-club.jpeg"),
          year: "2019",
          title: "Global Investor Award",
          alt: "Global Investor Award",
        },
        {
          img: require("../assets/images/about-barka.jpeg"),
          year: "2018",
          title: "Best African Entrepreneur",
          alt: "Best African Entrepreneur",
        },
        {
          img: require("../assets/images/mshel-club.jpeg"),
          year: "2017",
          title: "Social Impact Award",
          alt: "Social Impact Award",
        },
        {
          img: require("../assets/images/about-barka.jpeg"),
          year: "2016",
          title: "Leadership Award",
          alt: "Leadership Award",
        },
      ],
      slideInterval: null,
    };
  },
  mounted() {
    this.setResponsiveCards();
    window.addEventListener("resize", this.setResponsiveCards);

    this.slideInterval = setInterval(this.nextSlide, 3000);
  },
  beforeDestroy() {
    clearInterval(this.slideInterval);
    window.removeEventListener("resize", this.setResponsiveCards);
  },
  methods: {
    setResponsiveCards() {
      const width = window.innerWidth;
      if (width < 640) {
        this.cardsPerSlide = 1;
      } else if (width < 768) {
        this.cardsPerSlide = 2;
      } else if (width < 1024) {
        this.cardsPerSlide = 3;
      } else {
        this.cardsPerSlide = 4;
      }
      this.totalSlides = Math.ceil(this.awards.length / this.cardsPerSlide);
    },
    nextSlide() {
      if (this.activeIndex < this.totalSlides + 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    prevSlide() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex = this.totalSlides - 1;
      }
    },
  },
};
</script>

<style scoped>
.carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease-in-out;
}
</style>
